export const tachoModalTranslationsPl = {
    tachoModalReadonly: '(tylko do odczytu)',
    tachoModalCancel: 'Anuluj',
    tachoModalClose: 'Zamknij',
    tachoModalSave: 'Zapisz',
    tachoModelSaveAndNext: 'Zapisz i następny',
};

export const tachoModalTranslationsEn = {
    tachoModalReadonly: '(readonly)',
    tachoModalCancel: 'Cancel',
    tachoModalClose: 'Close',
    tachoModalSave: 'Save',
    tachoModelSaveAndNext: 'Save and next',
};
